<template>
  <a-dropdown :trigger="['click']">
    <a class="main-text-color" :style="style" @click.prevent>
      {{ langMap[$i18n.locale] }}
      <DownOutlined />
    </a>
    <template #overlay>
      <a-menu @click="languageChange">
        <a-menu-item v-for="(value, key) in langMap" :key="key" :disabled="$i18n.locale === key">
          {{ value }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { useStore } from 'vuex'
export default {
  name: 'LangSelector',
  props: {
    style: {
      type: String,
      default () {
        return ''
      }
    }
  },
  setup () {
    const store = useStore()
    const langMap = {
      zh: '中文',
      en: 'English'
    }

    const languageChange = async (e) => {
      localStorage.setItem('locale-language', e.key)
      await store.dispatch('getLanguage')
      // await store.dispatch('getAreaList')
      location.reload()
    }

    return {
      languageChange,
      langMap
    }
  }
}
</script>
<style lang="less" scoped>
.ant-dropdown-menu {
  width: 206px;
  height: 110px;
  padding: 12px;
  background: #fff;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  .ant-dropdown-menu-item {
    border-radius: 8px;
  }
  .ant-dropdown-menu-item:hover {
    background-color: rgba(142, 105, 53, 0.1);
  }
}
</style>

